import { autoinject, bindable } from 'aurelia-framework';

@autoinject
export class ViewHeaderBig {
  @bindable private badgeClass: string;
  @bindable private singleCol: boolean = false;
  constructor() {}
}
